import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { createPackage } from "../../api/apiPackages";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

const useCreatePackage = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: createPackageMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: createPackage,
        onSuccess: (response) => {
            toast.success(response.message);
            navigate('/packages');
            queryClient.invalidateQueries({ queryKey: ["packages"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to create package");
        },
    });

    return {
        createPackageMutate,
        isPending: isPending || isLoading,
    };
};

export default useCreatePackage;
